import type { IconSvgObject } from './types';

const DiagonalScrollPoint01Icon: IconSvgObject = [
  ["path", { d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 19.8826C10 19.8826 5.24049 20.3097 4.46539 19.5346C3.6903 18.7595 4.11739 14 4.11739 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 4.11735C14 4.11735 18.7595 3.69033 19.5346 4.46542C20.3097 5.2405 19.8826 10 19.8826 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DiagonalScrollPoint01Icon;
